var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1732_",
    fill: "#FFFFFF",
    d: "M199.081,54.208l-23.146,72.905c-1.734,5.192-6.275,8.653-11.681,8.653H74.905 c-5.192,0-10.167-3.245-11.898-8.006l-34.181-91.51H9.139c-4.759,0-8.653-3.892-8.653-8.653c0-4.76,3.894-8.654,8.653-8.654h25.745 c3.674,0,6.92,2.379,8.221,5.842l35.262,93.673h82.208l18.389-58.411H77.069c-4.758,0-8.653-3.892-8.653-8.653 c0-4.76,3.896-8.654,8.653-8.654h113.791c2.812,0,5.407,1.516,6.925,3.679C199.515,48.584,199.946,51.61,199.081,54.208z  M79.232,147.232c-3.677,0-7.356,1.514-9.953,4.109c-2.597,2.597-4.108,6.273-4.108,9.951c0,3.676,1.512,7.356,4.108,9.95 c2.598,2.594,6.276,4.11,9.953,4.11s7.353-1.518,9.951-4.11c2.597-2.596,4.111-6.274,4.111-9.95c0-3.681-1.514-7.355-4.111-9.951 S82.909,147.232,79.232,147.232z M156.895,147.232c-3.678,0-7.354,1.514-9.948,4.109c-2.598,2.597-4.111,6.273-4.111,9.951 c0,3.676,1.516,7.356,4.111,9.95c2.597,2.594,6.272,4.11,9.948,4.11c3.679,0,7.357-1.518,9.954-4.11 c2.594-2.596,4.107-6.274,4.107-9.95c0-3.681-1.515-7.355-4.107-9.951C164.252,148.746,160.575,147.232,156.895,147.232z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3e3ab1bcb34cc7475faec0ee025d548d.svg";
export { ForwardRef as ReactComponent };